/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type YearOfBirthDictionaryDto = {
    key?: YearOfBirthDictionaryDto.key;
    displayValue?: string;
};
export namespace YearOfBirthDictionaryDto {
    export enum key {
        YEAR_2007 = 'YEAR_2007',
        YEAR_2008 = 'YEAR_2008',
        YEAR_2009 = 'YEAR_2009',
        YEAR_2010 = 'YEAR_2010',
        YEAR_2011 = 'YEAR_2011',
        YEAR_2012 = 'YEAR_2012',
        YEAR_2013 = 'YEAR_2013',
        YEAR_2014 = 'YEAR_2014',
        YEAR_2015 = 'YEAR_2015',
        YEAR_2016 = 'YEAR_2016',
        YEAR_2017 = 'YEAR_2017',
        YEAR_2018 = 'YEAR_2018',
        YEAR_2019 = 'YEAR_2019',
        YEAR_2020 = 'YEAR_2020',
    }
}

